import React, { useContext } from "react";
import PropTypes from "prop-types";
import { translate } from "react-polyglot";
import { SecondaryButton, PrimaryButton } from "../buttons";
import Modal from "../Modal";
import Text from "../edu/Text";
import { FormContext } from "../../context/form-context";

import "./SaveEntryModal.css";

const SaveEntryModal = props => {
  const {
    saveEntryModalShown,
    hideTrackerModals,
    showPreviousModal,
    t
  } = props;

  const formContext = useContext(FormContext);

  const onSubmit = () => {
    formContext.functions.onSubmit(formContext.formValues);
  }

  return (
    <Modal
      isOpen={saveEntryModalShown}
      showCloseButton={false}
      onRequestClose={hideTrackerModals}
    >
      <h5 className="saveentry-modal__title">{t("tracker.saveEntryTitle")}</h5>
      <Text className="saveentry-modal__text">
        {t("tracker.saveEntryDescription")}
      </Text>
      <Text className="saveentry-modal__text">
        {t("tracker.saveEntryCaption")}
      </Text>
      <div className="saveentry-modal__footer">
        <PrimaryButton
          colorScheme="blue"
          label={t("tracker.rejectDelete")}
          onClick={showPreviousModal}
        />
        <SecondaryButton
          colorScheme="red"
          label={t("tracker.save")}
          onClick={onSubmit}
        />
      </div>
    </Modal>
  );
};

SaveEntryModal.defaultProps = {
  saveEntryModalShown: false,
  hideTrackerModals: () => {},
  showPreviousModal: () => {},
  t: () => {}
};

SaveEntryModal.propTypes = {
  saveEntryModalShown: PropTypes.bool,
  hideTrackerModals: PropTypes.func,
  showPreviousModal: PropTypes.func,
  t: PropTypes.func
};

export default translate()(SaveEntryModal);



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/SaveEntryModal.js